import React from "react";

import { SubStepLabels } from "../SubStepLabels";

export const TestDriveSteps = (props: any) => {
  const { testDriveStepsList } = props;

  return (
    <div className={"flex flex-col justify-start items-start"}>
      {testDriveStepsList.map((step: any) => (
        <SubStepLabels key={step.name} step={step} />
      ))}
    </div>
  );
};
